import React from 'react';

interface AlyzeImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  loading?: 'lazy' | 'eager';
  style?: React.CSSProperties;
}

export const AlyzeImage: React.FC<AlyzeImageProps> = ({
  src,
  alt,
  width,
  height,
  className,
  loading = 'lazy',
  style
}) => {
  const baseUrl = import.meta.env.VITE_MEDIA_CDN_URL || 'https://d28ffuj7bighkv.cloudfront.net';
  const fullSrc = src.startsWith('http') ? src : `${baseUrl}/${src}`;
  
  return (
    <img 
      src={fullSrc}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading={loading}
      style={style}
    />
  );
};
